import Snackbar from "awesome-snackbar";

const DEFAULT_TIMEOUT = 4000;
const WARNING_TIMEOUT = 6000;
const ERROR_TIMEOUT = 8000;

export const snackbar = async (status, messsage) => {
  if (status === "success")
    return new Snackbar(`${messsage}`, {
      theme: "light",
      position: "top-center",
      timeout: DEFAULT_TIMEOUT,
      style: {
        container: [
          ["background-color", "green"],
          ["color", "white"],
        ],
      },
    });
  else if (status === "error")
    return new Snackbar(`${messsage}`, {
      theme: "light",
      position: "top-center",
      timeout: ERROR_TIMEOUT,
      style: {
        container: [
          ["background-color", "red"],
          ["color", "white"],
        ],
      },
    });
  else if (status === "warning")
    return new Snackbar(`${messsage}`, {
      theme: "light",
      position: "top-center",
      timeout: WARNING_TIMEOUT,
      style: {
        container: [
          ["background-color", "orange"],
          ["color", "white"],
        ],
      },
    });
};
